import { CreatedByUser } from '../../types/apps/apps.types';
import { FeatureName } from '../Feature/feature';

/**
 * Web Dash "Time off" module (id 74, key `time-off`).
 * MoM continues to use module 5 (`employee-time-off`).
 */
export const TIME_OFF_WEB_DASH_MODULE_ID = 74;

export const timeOffWebDashModuleList = [
  {
    id: TIME_OFF_WEB_DASH_MODULE_ID,
    moduleName: 'Time off',
    key: 'time-off',
    createdBy: CreatedByUser.SYSTEM,
  },
] as const;

export const timeOffWebDashAppModule = [{ appId: 4, moduleId: TIME_OFF_WEB_DASH_MODULE_ID }];

export const employeeTimeOffAdminFeatures = {
  'time-off-policy': { id: 242, featureName: FeatureName.TIME_OFF_POLICY },
  'time-off-allocation': { id: 243, featureName: FeatureName.TIME_OFF_ALLOCATION },
  'time-off-leave-overview': { id: 244, featureName: FeatureName.TIME_OFF_LEAVE_OVERVIEW },
  'time-off-requests': { id: 245, featureName: FeatureName.TIME_OFF_REQUESTS },
  'time-off-settings': { id: 246, featureName: FeatureName.TIME_OFF_SETTINGS },
} as const;

export const employeeTimeOffAdminFeatureList = Object.entries(employeeTimeOffAdminFeatures).map(([key, v]) => ({
  key,
  ...v,
  createdBy: CreatedByUser.SYSTEM,
}));

export const employeeTimeOffAdminModuleFeaturesList = Object.values(employeeTimeOffAdminFeatures).map((f) => ({
  moduleId: TIME_OFF_WEB_DASH_MODULE_ID,
  featureId: f.id,
}));
